module.exports = __webpack_public_path__ + "static/media/Logo-GVIS.edd41b37.jpg";